var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3783 3061",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:86.3715}\r\n    .fil0 {fill:none}\r\n    .fil4 {fill:black}\r\n    .fil5 {fill:#9C0000}\r\n    .fil1 {fill:red}\r\n    .fil3 {fill:white}\r\n    .fil2 {fill:white;fill-rule:nonzero}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_650659232"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 3783,
    height: 3061
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M1891 571c-121,-2 -824,25 -1227,894 -489,1054 424,1184 1227,1184 802,-2 1718,-129 1228,-1184 -404,-869 -1106,-896 -1228,-894z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1666 1777l-172 0 0 0 0 -8 -1 -7 0 -8 -2 -7 -1 -8 -2 -7 -2 -7 -3 -7 -2 -6 -3 -6 -3 -7 -4 -6 -4 -5 -4 -6 -4 -5 -4 -5 -4 -5 -5 -4 -5 -4 -5 -4 -5 -3 -5 -4 -5 -3 -5 -2 -6 -3 -5 -2 -6 -1 -6 -2 -5 -1 -6 -1 -6 0 -6 0 0 -173 15 0 16 2 15 2 15 3 15 3 14 5 14 5 14 6 13 7 13 7 13 8 12 8 11 9 11 10 11 10 10 11 10 11 9 11 8 12 9 13 7 13 7 13 6 13 6 14 5 14 5 15 3 15 4 15 2 15 2 16 1 15 0 16 0 0zm-296 318l0 -173 0 0 6 0 6 -1 6 -1 5 -1 6 -1 6 -2 5 -2 6 -2 5 -3 5 -3 5 -3 5 -4 5 -3 5 -5 5 -4 4 -5 4 -5 4 -5 4 -5 4 -6 4 -6 3 -6 3 -6 2 -7 3 -7 2 -7 2 -7 1 -7 2 -7 0 -8 1 -8 0 -8 172 0 0 16 -1 16 -2 15 -2 16 -4 15 -3 15 -5 14 -5 14 -6 14 -6 14 -7 13 -7 13 -9 12 -8 12 -9 12 -10 11 -10 11 -11 10 -11 9 -11 9 -12 9 -13 8 -13 7 -13 7 -14 5 -14 6 -14 4 -15 4 -15 3 -15 2 -16 1 -15 1 0 0zm-297 -318l172 0 0 0 1 8 0 8 1 8 1 7 2 7 2 7 2 7 2 7 3 7 3 6 3 6 3 6 4 6 4 5 4 5 4 5 5 5 5 4 4 5 5 3 5 4 5 3 6 3 5 3 5 2 6 2 5 2 6 1 6 1 6 1 6 1 6 0 0 173 -16 -1 -15 -1 -15 -2 -15 -3 -15 -4 -15 -4 -14 -6 -13 -5 -14 -7 -13 -7 -12 -8 -12 -9 -12 -9 -11 -9 -10 -10 -11 -11 -9 -11 -9 -12 -9 -12 -8 -12 -8 -13 -6 -13 -7 -14 -5 -14 -6 -14 -4 -14 -4 -15 -3 -15 -3 -16 -1 -15 -1 -16 -1 -16 0 0zm297 -317l0 173 0 0 -6 0 -6 0 -6 1 -6 1 -6 2 -5 1 -6 2 -5 3 -5 2 -6 3 -5 4 -5 3 -5 4 -4 4 -5 4 -5 5 -4 5 -4 5 -4 6 -4 5 -3 6 -3 7 -3 6 -3 6 -2 7 -2 7 -2 7 -2 8 -1 7 -1 8 0 7 -1 8 -172 0 1 -16 1 -15 1 -16 3 -15 3 -15 4 -15 4 -15 6 -14 5 -14 7 -13 6 -13 8 -13 8 -13 9 -12 9 -11 9 -11 11 -11 10 -10 11 -10 12 -9 12 -8 12 -8 13 -7 14 -7 13 -6 14 -5 15 -5 15 -3 15 -3 15 -2 15 -2 16 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil3",
    d: "M1370 1546c116,0 210,104 210,231 0,128 -94,231 -210,231 -117,0 -211,-103 -211,-231 0,-127 94,-231 211,-231z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 1428,
    cy: 1780,
    r: 191
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M2117 1777l0 0 0 -16 1 -15 2 -16 2 -15 4 -15 3 -15 5 -15 5 -14 6 -14 6 -13 7 -13 7 -13 9 -13 8 -12 9 -11 10 -11 10 -11 11 -10 11 -10 11 -9 12 -8 13 -8 13 -7 13 -7 14 -6 14 -5 14 -5 15 -3 15 -3 15 -2 16 -2 15 0 0 173 -6 0 -6 0 -6 1 -5 1 -6 2 -6 1 -5 2 -6 3 -5 2 -5 3 -5 4 -5 3 -5 4 -5 4 -5 4 -4 5 -4 5 -4 5 -4 6 -4 5 -4 6 -3 7 -3 6 -2 6 -3 7 -2 7 -2 7 -1 8 -2 7 0 8 -1 7 0 8 0 0 -172 0zm296 318l0 0 -15 -1 -16 -1 -15 -2 -15 -3 -15 -4 -14 -4 -14 -6 -14 -5 -13 -7 -13 -7 -13 -8 -12 -9 -11 -9 -11 -9 -11 -10 -10 -11 -10 -11 -9 -12 -8 -12 -9 -12 -7 -13 -7 -13 -6 -14 -6 -14 -5 -14 -5 -14 -3 -15 -4 -15 -2 -16 -2 -15 -1 -16 0 -16 172 0 0 8 1 8 0 8 2 7 1 7 2 7 2 7 3 7 2 7 3 6 3 6 4 6 4 6 4 5 4 5 4 5 4 5 5 4 5 5 5 3 5 4 5 3 5 3 5 3 6 2 5 2 6 2 6 1 5 1 6 1 6 1 6 0 0 0 0 173zm297 -318l0 0 -1 16 -1 16 -1 15 -3 16 -3 15 -4 15 -4 14 -6 14 -5 14 -7 14 -7 13 -7 13 -8 12 -9 12 -9 12 -9 11 -11 11 -10 10 -11 9 -12 9 -12 9 -12 8 -13 7 -14 7 -13 5 -14 6 -15 4 -15 4 -15 3 -15 2 -15 1 -16 1 0 -173 6 0 6 -1 6 -1 6 -1 6 -1 5 -2 6 -2 5 -2 5 -3 6 -3 5 -3 5 -4 5 -3 4 -5 5 -4 5 -5 4 -5 4 -5 4 -5 4 -6 3 -6 3 -6 3 -6 3 -7 2 -7 2 -7 2 -7 2 -7 1 -7 1 -8 0 -8 1 -8 0 0 172 0zm-297 -317l0 0 16 0 15 2 15 2 15 3 15 3 15 5 14 5 13 6 14 7 13 7 12 8 12 8 12 9 11 10 10 10 11 11 9 11 9 11 9 12 8 13 7 13 7 13 7 13 5 14 6 14 4 15 4 15 3 15 3 15 1 16 1 15 1 16 -172 0 -1 -8 0 -7 -1 -8 -1 -7 -2 -8 -2 -7 -2 -7 -2 -7 -3 -6 -3 -6 -3 -7 -3 -6 -4 -5 -4 -6 -4 -5 -4 -5 -5 -5 -5 -4 -4 -4 -5 -4 -5 -3 -5 -4 -6 -3 -5 -2 -5 -3 -6 -2 -5 -1 -6 -2 -6 -1 -6 -1 -6 0 -6 0 0 0 0 -173z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil3",
    d: "M2413 1546c-116,0 -210,104 -210,231 0,128 94,231 210,231 116,0 211,-103 211,-231 0,-127 -95,-231 -211,-231z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 2355,
    cy: 1780,
    r: 191
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil3",
    cx: 2298,
    cy: 1779,
    r: 75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil3",
    cx: 1485,
    cy: 1779,
    r: 75
  }), /*#__PURE__*/React.createElement("g", {
    id: "_650659064"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil5 str0",
    d: "M825 567l0 0c34,-34 92,-28 124,9l426 496c76,88 -58,203 -134,115l-426 -496c-31,-37 -24,-90 10,-124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5 str0",
    d: "M447 1152c-94,-79 -80,-223 4,-291l343 -279c43,-35 101,-48 143,-12l0 0c43,36 40,95 13,144l-217 385c-50,89 -193,132 -286,53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil5 str0",
    d: "M2958 567l0 0c-34,-34 -93,-28 -124,9l-426 496c-76,88 58,203 134,115l426 -496c31,-37 24,-90 -10,-124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5 str0",
    d: "M3336 1152c94,-79 80,-223 -4,-291l-343 -279c-43,-35 -101,-48 -144,-12l0 0c-42,36 -39,95 -12,144l217 385c50,89 193,132 286,53z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_650659424"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M1347 2255c-685,392 278,665 367,556 23,-28 -514,-110 -198,-367 115,-94 -58,-252 -169,-189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M2436 2255c685,392 -278,665 -367,556 -23,-28 514,-110 198,-367 -115,-94 58,-252 169,-189z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni14);
export default __webpack_public_path__ + "static/media/ani14.a201761221b3e515506493e6be871399.svg";
export { ForwardRef as ReactComponent };